import React, { useState, useRef, useEffect } from "react";
import {
  SarahAudioInfo,
  PauseBtnIcon,
  AudioWaveTimeline,
  PlayBtnIcon,
} from "@/atoms/Icons";

export default function AudioStrip({
  audioFile,
  audioInfoColor = "white",
  audioWaveTimeLineColor = "#8bb8e0",
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const timelineRef = useRef(null);

  useEffect(() => {
    const timelineRefs = timelineRef.current.childNodes;
    const waveLinesCount = timelineRefs.length;

    if (audioRef.current) {
      const changePathColor = () => {
        const playPercent =
          (audioRef.current.currentTime / audioRef.current.duration) * 100;
        const currentPath =
          timelineRefs[Math.floor((playPercent / 100) * waveLinesCount)];
        if (currentPath) {
          currentPath.classList.add("tc-fill");
          const nextSibling = currentPath.nextElementSibling;
          const prevSibling = currentPath.previousElementSibling;
          if (prevSibling) prevSibling.classList.add("tc-fill");
          if (nextSibling) nextSibling.classList.add("tc-fill");
        }
      };

      audioRef.current?.addEventListener("timeupdate", changePathColor);

      return () => {
        audioRef.current?.removeEventListener("timeupdate", changePathColor);
      };
    }
  }, []);

  const handleAudioEnd = () => {
    const timelineRefs = timelineRef.current.childNodes;
    timelineRefs.forEach((path) => path.classList.remove("tc-fill"));
    setIsPlaying(false);
  };

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      <div className="fx fx--order-1-d mb-4 mb-reset-d">
        <button className="audio-btn" onClick={handlePlayPause}>
          {!isPlaying ? (
            <PlayBtnIcon width="60" height="60" className="mr-3-d mr-2" />
          ) : (
            <PauseBtnIcon />
          )}
        </button>
        <audio ref={audioRef} src={audioFile} onEnded={handleAudioEnd} />
        <AudioWaveTimeline
          ref={timelineRef}
          className="audioWaveLine"
          color={audioWaveTimeLineColor}
        ></AudioWaveTimeline>
      </div>
      <SarahAudioInfo
        color={audioInfoColor}
        className="text mb-1-d"
      ></SarahAudioInfo>
    </>
  );
}
